/**
 * Desde cuándo corre el reloj de inactividad (2 h, `useIdleTimeout`).
 *
 * La última actividad vive en localStorage para que las pestañas compartan el
 * reloj, y por eso sobrevive al cierre del navegador; los tokens y el inicio
 * de la sesión viven en sessionStorage y no. Así que una marca anterior al
 * login es de una sesión que ya terminó: iniciar sesión ES actividad.
 *
 * Hasta el 07-oct-2026 el reloj arrancaba de esa marca vieja. Quien había
 * cerrado la pestaña hacía más de 2 h sin pulsar «Salir» entraba, el reloj
 * vencía en el acto y lo deslogueaba; las primeras llamadas del Panel salían
 * sin token, el 401 mandaba a Cognito, que devolvía un código sin preguntar, y
 * la persona veía el login dos veces antes de entrar.
 */
export function inicioDelReloj(ultimaActividad: number, inicioSesion: number, ahora: number): number {
  const valida = (t: number) => (Number.isFinite(t) && t > 0 ? t : 0)
  const desde = Math.max(valida(ultimaActividad), valida(inicioSesion))
  return desde > 0 ? desde : ahora
}
